<!--
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2024-05-30 16:31:33
 * @LastEditors: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @LastEditTime: 2024-05-31 09:54:10
 * @FilePath: /front-vps-admin/src/web-framework/components/OrganSelector/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <el-cascader ref="organCascadeSelector" v-model="selectedOptions" :options="organTree" :props="{ label: 'name', value: 'id', expandTrigger: 'hover' }" placeholder="选择组织" clearable style="min-width:300px" @change="handleChange"></el-cascader>
</template>

<script>
import OrganAPI from '@/web-framework/api/organ';
export default {
    name: "OrganSelector",
    props: {
        value: {
            type: String,
            required: true,
            default: null
        }
    },
    data() {
        return {
            organTree: [],
            selectedOptions: ['root'],
        }
    },
    watch: {
        // 监听 val 的变化，确保 localValue 与之同步
        value(newVal) {
            this.setSelectedOptions(newVal);
        },
        // // 监听内部值的变化并通知父组件  
        // selectedValue: {
        //     handler(newVal) {
        //         let childId = this.getSelectedChildValue();
        //         this.$emit('input', childId);
        //     },
        //     deep: true // 因为我们传递的是一个数组或对象，所以需要深度监听  
        // }
    },
    mounted() {
        // 加载组织
        this.loadOrganTree();
    },
    methods: {
        loadOrganTree() {
            OrganAPI.loadOrganTree().then(result => {
                Request.validateResult(result, () => {
                    Vue.set(this, 'organTree', result.data || []);
                    // this.setSelectedOptions(this.value);
                });

            }).catch(error => { });
        },
        setSelectedOptions(value) {
            // 这里假设你有一个方法来根据子节点 ID 找到整个路径  
            // 你需要根据你的数据结构来实现这个方法  
            const path = this.findPathByValue(this.organTree, value);
            // 设置 selectedOptions，确保路径中的所有节点都被选中  
            this.selectedOptions = path.map(item => item.id);
        },
        findPathByValue(options, value) {
            let path = [];
            let find = function (options, parent) {
                for (let option of options) {
                    if (option.id === value) {
                        path.unshift(parent || option); // 如果找到，将父节点或当前节点加入路径  
                        return;
                    }
                    if (option.children) {
                        find(option.children, option); // 递归查找子节点  
                    }
                }
            }
            find(options);
            return path;
        },
        handleChange(value) {
            // 当输入框内容发生变化时，发出 input 事件并将新的值作为参数传递
            this.$emit('input', value[value.length - 1]);
            // this.$emit('update:selectedValue', value[value.length - 1]);
        }
    }
}
</script>